import pageheader from "../pageheader";
import { mapGetters } from "vuex";
import utils from "../../utils/util";
import moment from "moment";
import telematicsService from "../../api/telematics.service";

import XLSX from "xlsx";
import rules from "../../utils/rules";
import config from "../../../secrets/config";

export default {
  name: "customer-owned-equipment",
  components: { pageheader },
  data() {
    return {
      input: {},
      search: "",
      contractNumber: "",
      fromDate: "",
      toDate: "",
      status: "",
      customerDataList: [],
      excelListCust: [],
      excelHeaderCust: [],
      startrowCust: "",
      iscustomerDataLoading: false,
      showCustDialog: false,
      description: "",
      customerEquipmentName: "",
      contractor: "",
      startDate: "",
      endDate: "",
      jobSite: null,
      menu5: false,
      menu6: false,
      equipmentId: "",
      editCustomerOwnedEquipmentDetails: false,
      configdata: config.ENABLE_ACCESS_CODE,
      locations: [],
      locationSearchFilter: null,
      loadinglocations: false,
      // Referenced by the jobsite autocomplete's `selection` slot
      // (CustomerOwnedEquipment.html) in the `index === 1` branch. That branch is
      // unreachable while the autocomplete is single-select, but the identifier was
      // undeclared, so it would have thrown the moment it was reached.
      selectedLocation: [],
      dateCheck: false,
      showdisable: false,
      dateErrorMsg: "",

      headers: [
        { text: "Serial Number", value: "referenceNumber" },
        { text: "Customer Name", value: "customerName" },
        { text: "Equipment #", value: "name" },
        { text: "Equipment Name", value: "customerEquipmentName" },
        {
          text: "Estimated Battery Lifespan (days)",
          value: "estimatedBatteryLifespan",
        },
        { text: "Hours", value: "hours" },

        { text: "Jobsite", value: "jobSite" },
        { text: "Geofence", value: "geofence" },

        { text: "Description", value: "description" },

        { text: "Contractor", value: "contractor" },

        { text: "Start Date", value: "startDate" },

        { text: "End Date", value: "endDate" },

      ],
      equipmentHashName: "",
      jobSiteRadioInput: "2",
      newJobSite: "",
      jobSiteId: null,
      toggle_exclusive: undefined,
      pageNumber: 1,
      pageSize: 52,
      totalRecords: 0,
      totalRecordsCount: 0,
      isContractsLoading: false,
      countLables: [
        {
          name: "25",
          count: 25,
        },
        {
          name: "50",
          count: 50,
        },
        {
          name: "52",
          count: 52,
        },
        {
          name: "ALL",
          count: -1,
        },
      ],
      tempacccode: null,
      shownodata: false,
      isFilter: false,
      isExcel: false,
      accessControlCodeDialog: false,
      unAssignConfirmationDivOpen: false,
      defaultAccessControlCode: "",
      defaultAccessControlCodeUnitId: "",
      isUnAssignedBtnSubmit: false,
      assignNewCodeDivOpen: false,
      accessKeysList: [],
      isGetAccessKeys: false,
      newAssignedCode: "",
      isAssignNewCodeBtnSubmit: false,
      createAssignNewCodeDivOpen: false,
      controlCodeFormValid: true,
      rules: rules,
      controlCodeName: "",
      controlCodeSerialNumber: "",
      keyValidList: [
        { name: "30Sec", value: "30Sec" },
        { name: "60Sec", value: "60Sec" },
        { name: "90Sec", value: "90Sec" },
      ],
      selectedKeyValid: "",
      keyExpireList: [
        { name: "0sec", value: "0sec" },
        { name: "15sec", value: "15sec" },
        { name: "30sec", value: "30sec" },
        { name: "60sec", value: "60sec" },
        { name: "2min", value: "2min" },
        { name: "5min", value: "5min" },
        { name: "10min", value: "10min" },
        { name: "15min", value: "15min" },
        { name: "30min", value: "30min" },
        { name: "1hour", value: "1hour" },
        { name: "2hours", value: "2hours" },
        { name: "4hours", value: "4hours" },
        { name: "8hours", value: "8hours" },
        { name: "16hours", value: "16hours" },
      ],
      selectedKeyExpire: "",
      controlCodeNotes: "",
      isCreateAndAssignBtnSubmit: false,
      selectedAccessCodeCustomerId: "",
      selectedAccessCodeOwnerType: "2",
    };
  },
  computed: {
    ...mapGetters(["roles", "companyNameDropdown", "activeToggleBtnVal"]),
    startPageCount() {
      return this.pageNumber == -1
        ? 1
        : (this.pageNumber - 1) * this.pageSize + 1;
    },
    endPageCount() {
      return this.pageNumber == -1 || this.pageNumber == 1
        ? this.customerDataList.length
        : (this.pageNumber - 1) * this.pageSize + this.customerDataList.length;
    },
  },
  created() {
    this.toggle_exclusive = this.activeToggleBtnVal;
  },
  mounted() {
    // getting input content
    this.input = utils.getInputContent("customerOwnedEquipment", this.roles);
    if (this.$route.query && this.$route.query.isFilter) {
      this.contractNumber = this.$route.query.serialNumber;
      this.isFilter = this.$route.query.isFilter;
    }
    if (this.$route.query && this.$route.query.toggleId) {
      this.toggle_exclusive = this.$route.query.toggleId;
    }
    this.readDataFromApi();
  },
  beforeDestroy() {
    //clear the stored toggleBtn Val on page destroy
    this.$store.dispatch("setActiveToggleVal", 0);
  },
  watch: {
    locationSearchFilter(val) {
      if (val != undefined && val != null) {
        return val.replace(/^\s+|\s+$/gm, "");
      }
    },
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      } else {
        let emptydata = "";
        return emptydata;
      }
    },
  },
  methods: {
    radioInputChange() {
      if (this.jobSiteRadioInput == "1") {
        this.newJobSite = "";
        this.jobSite = null;
      } else {
        this.jobSiteId = null;
      }
    },
    async getLocations() {
      try {
        this.loadinglocations = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.locations = response.data
            .filter((e) => e.locationName != null)
            .map((item) => {
              return {
                locationName: item.locationName,
                locationId: item.locationId,
              };
            });
          this.loadinglocations = false;
        }
      } catch (err) {
        this.loadinglocations = false;
      }
    },
    getList(item, queryText, itemText) {
      return itemText
        .toLocaleLowerCase()
        .startsWith(queryText.toLocaleLowerCase().trim());
    },
    datesCompare() {
      if (this.startDate && this.endDate) {
        let dateCheck =
          moment(this.endDate).format("YYYY-MM-DD") >=
          moment(this.startDate).format("YYYY-MM-DD");
        this.dateCheck = dateCheck;

        if (!this.dateCheck) {
          this.dateErrorMsg = "To Date should be greater than From Date";
          this.showdisable = true;
        }
      } else {
        this.dateCheck = false;
        this.showdisable = false;
      }
    },
    clearDates1() {
      if (this.startDate) {
        this.startDate = "";
      }

      this.dateErrorMsg = "";
      this.showdisable = false;
    },
    clearDates2() {
      if (this.endDate) {
        this.endDate = "";
      }
      this.dateErrorMsg = "";
      this.showdisable = false;
    },
    async editCustomerOwnedEquipment(item) {
      this.showCustDialog = true;
      this.contractor = item.contractor;
      this.equipmentId = item.equipmentId;
      this.description = item.description;
      this.equipmentHashName = item.name;
      this.customerEquipmentName = item.customerEquipmentName;
      if (item.startDate) {
        this.startDate = item.startDate;
      }
      if (item.endDate) {
        this.endDate = item.endDate;
      }
      this.datesCompare();
      await this.getLocations();
      if (item.jobSiteId != null && item.jobSiteId != "") {

        this.jobSiteRadioInput = "1";


        this.jobSiteId = this.locations.filter(
          (e) => e.locationId == item.jobSiteId
        )[0];
      } else {
        this.jobSiteRadioInput = "2";
        this.jobSiteId = null;
        this.newJobSite = item.jobSite;
        this.jobSite = this.newJobSite;
      }
    },
    clearfields() {
      this.showCustDialog = false;
      this.contractor = "";
      this.equipmentId = "";
      this.jobSiteRadioInput = "2";
      this.startDate = "";
      this.endDate = "";
      this.description = "";
      this.customerEquipmentName = "";
      this.dateErrorMsg = "";
      this.dateCheck = false;
    },
    accessCodeClose(item) {
      this.tempacccode = item;
      this.openUnAssignConfirmation();
    },
    onToggleChange() {
      this.$store.dispatch("setActiveToggleVal", this.toggle_exclusive);
      this.readDataFromApi();
    },
    viewCustoemrDataDetails(assetId) {
      if (this.$route.query && this.$route.query.isFilter) {
        this.$router.push({
          name: "View Customer Owned Equipment Details",
          params: { assetId: assetId },
          query: {
            serialNumber: this.contractNumber,
            isFilter: this.isFilter,
            toggleId: this.toggle_exclusive,
          },
        });
      } else {
        this.$router.push({
          name: "View Customer Owned Equipment Details",
          params: { assetId: assetId },
          query: {
            serialNumber: "",
            isFilter: this.isFilter,
            toggleId: this.toggle_exclusive,
          },
        });
      }
    },
    clearFilters() {
      this.fromDate = "";
      this.toDate = "";
      this.contractNumber = "";
      this.status = "";
      this.$router.replace(`/customer-owned-equipment`);
      this.readDataFromApi();
    },

    pageChange() {
      this.readDataFromApi();
    },
    async readDataFromApi() {
      if (this.contractNumber) {
        this.isFilter = true;
        this.$router
          .replace(
            `/customer-owned-equipment?serialNumber=${this.contractNumber}&isFilter=${this.isFilter}&toggleId=${this.toggle_exclusive}`
          )
          .catch(() => {});
      } else {
        this.isFilter = false;
        this.contractNumber = "";
        this.$router.replace(`/customer-owned-equipment`).catch(() => {});
      }
      this.iscustomerDataLoading = true;
      this.customerDataList = [];
      let num = "";
      try {
        let response = await telematicsService.getcustomerDataList(
          num,
          this.fromDate,
          this.toDate,
          this.contractNumber,
          this.pageNumber,
          this.pageSize
        );
        if (response) {
          this.iscustomerDataLoading = false;
          this.customerDataList = response.data.map((d) => ({
            ...d,
            startDate: d.startDate ? d.startDate.split("T")[0] : "",
            endDate: d.endDate ? d.endDate.split("T")[0] : "",
          }));

          if (this.customerDataList.length == 0) {
            this.shownodata = true;
          } else {
            this.shownodata = false;
          }


          this.totalRecordsCount = response.totalRecords;

          let totalRecords = Math.ceil(this.totalRecordsCount / this.pageSize);
          if (this.pageSize == -1) {
            this.totalRecords = 1;
          } else {
            this.totalRecords = parseInt(totalRecords);
          }
        } else {
          this.iscustomerDataLoading = false;
          this.customerDataList = [];
          this.shownodata = false;
        }
      } catch (err) {
        console.log(err);
        this.iscustomerDataLoading = false;
        this.customerDataList = [];
        this.shownodata = false;
      }
    },
    async exportTableDataCust() {
      this.isExcel = true;
      let pageNumber = 1;
      let pageSize = -1;
      let num = "";
      this.excelListCust = [];
      try {
        let response = await telematicsService.getcustomerDataList(
          num,
          this.fromDate,
          this.toDate,
          this.contractNumber,
          pageNumber,
          pageSize
        );
        if (response) {
          this.isExcel = false;
          let customerDataList = response.data;
          this.excelListCust = customerDataList.map((item) => {
            return {
              customerName: item.customerName ? item.customerName : "",
              serialNumber: item.serialNumber ? item.serialNumber : "",
              name: item.name ? item.name : "",
              customerEquipmentName: item.customerEquipmentName
                ? item.customerEquipmentName
                : "",
              estimatedBatteryLifespan: item.estimatedBatteryLifespan
                ? item.estimatedBatteryLifespan
                : "",
              hours: item.hours ? item.hours : "",
              jobSite: item.jobSite ? item.jobSite : "",
              customerId:
                this.selectedCustomer != null
                  ? this.selectedCustomer["id"]
                  : "",
              description: item.description ? item.description : "",
              contractor: item.contractor ? item.contractor : "",
              startDate: item.startDate ? item.startDate.split("T")[0] : "",
              endDate: item.endDate ? item.endDate.split("T")[0] : "",

              accessControlCods:
                item.accessCods.length != 0
                  ? item.accessCods.map((e) => e.accessControlCode).join()
                  : "",
              geofence: item.geofence ? item.geofence : "",
            };
          });
          this.excelHeaderCust = [];
          this.startrowCust = 3;
          this.excelHeaderCust.push(["Customer Owned Equipment Data"]);
          this.startrowCust += 1;
          let cust;
          if (this.companyNameDropdown == "") {
            cust = "All";
          } else {
            cust = this.$store.getters.companyNameDropdown;
          }
          this.excelHeaderCust.push(["Customer:" + " " + cust]);
          if (this.fromDate) {
            this.startrowCust += 1;
            this.excelHeaderCust.push(["From Date:" + " " + this.fromDate]);
          }
          if (this.toDate) {
            this.startrowCust += 1;
            this.excelHeaderCust.push(["To Date:" + " " + this.toDate]);
          }
          if (this.contractNumber) {
            this.startrowCust += 1;
            this.excelHeaderCust.push([
              "Equipment #/Serial #/Jobsite :" + " " + this.contractNumber,
            ]);
          }
          this.excelHeaderCust.push([]);
          this.startrowCust += 1;

          this.excelHeaderCust.push([
            "Serial Number",
            "Customer Name",
            "Equipment #",
            "Equipment Name",
            "Estimated Battery Lifespan (Days)",
            "Hours",
            "Jobsite",
            "Description",
            "Contractor",
            "Start Date",
            "End Date",
            "Geofence",
          ]);
          let tempExcel = this.excelListCust.map(function (item) {
            delete item.unitId;
            // hide accesscontrolcode
            delete item.accessControlCods;
            return item;
          });
          let datarow = "A" + this.startrowCust;
          var ws = XLSX.utils.aoa_to_sheet(this.excelHeaderCust);
          XLSX.utils.sheet_add_json(ws, tempExcel, {
            header: [
              "serialNumber",
              "customerName",
              "name",
              "customerEquipmentName",
              "estimatedBatteryLifespan",
              "hours",

              "jobSite",
              "description",
              "contractor",
              "startDate",
              "endDate",
              "geofence",
            ],
            skipHeader: true,
            origin: datarow,
          });
          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Customer Owned Equipment Data");
          this.excelHeaderCust = [];
          XLSX.writeFile(wb, "Customer Owned Equipment Data.xlsx");
        } else {
          this.isExcel = false;
          this.excelListCust = [];
        }
      } catch (err) {
        console.log(err);
        this.isExcel = false;
        this.excelListCust = [];
      }
    },
    getFirstPageData() {
      this.pageNumber = 1;
      this.pageSize = 52;
      this.readDataFromApi();
    },
    getLastPageData() {
      this.pageNumber = this.totalRecords;
      this.pageSize = 52;
      this.readDataFromApi();
    },
    // Update Access Control Code Functionalities
    openAccessControlDialog(item) {
      this.defaultAccessControlCode = "";
      this.defaultAccessControlCodeUnitId = "";
      this.selectedAccessCodeCustomerId = "";
      this.accessControlCodeDialog = true;
      this.defaultAccessControlCode = item.accessCods;
      this.defaultAccessControlCodeUnitId = item.tuUnitId;
      this.selectedAccessCodeCustomerId = item.customerId;
    },
    cancelAccessControlDialog() {
      this.accessControlCodeDialog = false;
      this.unAssignConfirmationDivOpen = false;
      this.assignNewCodeDivOpen = false;
      this.createAssignNewCodeDivOpen = false;
      this.defaultAccessControlCode = "";
      this.defaultAccessControlCodeUnitId = "";
      this.selectedAccessCodeCustomerId = "";
      this.clearControlCodeFields();
    },
    // *---- First Btn UnAssign Code ------*
    clearControlCodeFields() {
      this.newAssignedCode = "";
      this.controlCodeName = "";
      this.controlCodeSerialNumber = "";
      this.selectedKeyExpire = "";
      this.selectedKeyValid = "";
      this.controlCodeNotes = "";
    },
    openUnAssignConfirmation() {
      this.unAssignConfirmationDivOpen = true;
      this.assignNewCodeDivOpen = false;
      this.createAssignNewCodeDivOpen = false;
      this.clearControlCodeFields();
    },
    cancelUnAssignConfirmation() {
      this.unAssignConfirmationDivOpen = false;
      this.assignNewCodeDivOpen = false;
      this.createAssignNewCodeDivOpen = false;
      this.tempacccode = null;

      this.clearControlCodeFields();
    },
    // Put call unassign
    async unAssignControlCode() {
      this.isUnAssignedBtnSubmit = true;
      let payload = {
        id: this.tempacccode.accessControlKeyId,

        unitId: this.defaultAccessControlCodeUnitId,
        customerId: this.selectedAccessCodeCustomerId,
        ownerType: this.selectedAccessCodeOwnerType,
        isGlobal: false,
      };
      try {
        let response = await telematicsService.unAssignAccessControlCode(
          payload
        );
        if (response.isSuccess) {
          this.$toast.success(
            "Access control code is unassigned successfully."
          );
          this.isUnAssignedBtnSubmit = false;
          this.cancelUnAssignConfirmation();
          this.cancelAccessControlDialog();
          this.readDataFromApi();
        } else {
          this.$toast.error(response.systemMessage);
          this.isUnAssignedBtnSubmit = false;
        }
      } catch (err) {
        console.log(err);
        this.$toast.error("Unable to unassign the access control code" + err);
        this.isUnAssignedBtnSubmit = false;
      }
    },
    // Assign New Code
    assignNewCodeDiv() {
      this.assignNewCodeDivOpen = true;
      this.getAccessKeysList();
      this.createAssignNewCodeDivOpen = false;
      this.unAssignConfirmationDivOpen = false;
      this.clearControlCodeFields();
    },
    cancelAssignNewCode() {
      this.assignNewCodeDivOpen = false;
      this.unAssignConfirmationDivOpen = false;
      this.createAssignNewCodeDivOpen = false;
      this.clearControlCodeFields();
    },
    async getAccessKeysList() {
      this.isGetAccessKeys = true;
      this.accessKeysList = [];
      try {
        let response = await telematicsService.getAccessKeysList(
          this.selectedAccessCodeCustomerId,
          this.selectedAccessCodeOwnerType
        );
        if (response && response.data) {
          this.isGetAccessKeys = false;
          let tempArrList = [];
          tempArrList = response.data.map(function (item) {
            return {
              companyName: item.companyName ? item.companyName : "",
              employeeNumber: item.employeeNumber ? item.employeeNumber : "",
              expirationDate: item.expirationDate ? item.expirationDate : "",
              id: item.id ? item.id : "",
              isAdmin: item.isAdmin ? item.isAdmin : "",
              keyExpire: item.keyExpire ? item.keyExpire : "",
              keyValid: item.keyValid ? item.keyValid : "",
              name: item.name ? item.name : "",
              note: item.note ? item.note : "",
              serialNumber: item.serialNumber ? item.serialNumber : "",
              showCodeName:
                (item.serialNumber ? item.serialNumber + " - " : "") +
                (item.name ? item.name : ""),
            };
          });
          this.accessKeysList = tempArrList;
        } else {
          this.isGetAccessKeys = false;
          this.$toast.error("No access codes available");
          this.accessKeysList = [];
        }
      } catch (err) {
        this.isGetAccessKeys = false;
        console.log(err);
      }
    },
    // Put call update & assign
    async updateAndAssignNewCode() {
      this.isAssignNewCodeBtnSubmit = true;
      let payload = {
        id: this.newAssignedCode,
        unitId: this.defaultAccessControlCodeUnitId,
        customerId: this.selectedAccessCodeCustomerId,
        ownerType: this.selectedAccessCodeOwnerType,
        isGlobal: false,
      };
      try {
        let response = await telematicsService.updateAndAssignNewCode(payload);
        if (response.isSuccess) {
          this.$toast.success(
            "New access control code is assigned successfully."
          );
          this.isAssignNewCodeBtnSubmit = false;
          this.cancelAssignNewCode();
          this.cancelAccessControlDialog();
          this.readDataFromApi();
        } else {
          this.$toast.error(response.systemMessage);
          this.isAssignNewCodeBtnSubmit = false;
        }
      } catch (err) {
        console.log(err);
        this.$toast.error("Unable to assign the new access control code" + err);
        this.isAssignNewCodeBtnSubmit = false;
      }
    },
    createAndAssignNewCodeDiv() {
      this.createAssignNewCodeDivOpen = true;
      this.assignNewCodeDivOpen = false;
      this.unAssignConfirmationDivOpen = false;
      this.clearControlCodeFields();
    },
    cancelCreateAndAssignNewCodeDiv() {
      this.createAssignNewCodeDivOpen = false;
      this.assignNewCodeDivOpen = false;
      this.unAssignConfirmationDivOpen = false;
      this.clearControlCodeFields();
    },
    //Post Call Create & Assign
    async createAndAssignNewCode() {
      this.isCreateAndAssignBtnSubmit = true;
      let unitIdList = [];
      if (this.defaultAccessControlCodeUnitId) {
        unitIdList.push(this.defaultAccessControlCodeUnitId);
      } else {
        unitIdList = [];
      }
      let payload = {
        name: this.controlCodeName,
        serialNumber: this.controlCodeSerialNumber,
        keyValid: this.selectedKeyValid,
        keyExpire: this.selectedKeyExpire,
        note: this.controlCodeNotes,
        units: unitIdList,
        customerId: this.selectedAccessCodeCustomerId,
        ownerType: this.selectedAccessCodeOwnerType,
        isGlobal: false,
      };
      try {
        let response = await telematicsService.createAndAssignNewCode(payload);
        if (response.isSuccess) {
          this.$toast.success(
            "Access control code is created & assigned successfully."
          );
          this.isCreateAndAssignBtnSubmit = false;
          this.cancelCreateAndAssignNewCodeDiv();
          this.cancelAccessControlDialog();
          this.readDataFromApi();
        } else {
          this.$toast.error(response.systemMessage);
          this.isCreateAndAssignBtnSubmit = false;
        }
      } catch (err) {
        console.log(err);
        this.$toast.error(
          "Unable to create & assign the access control code" + err
        );
        this.isCreateAndAssignBtnSubmit = false;
      }
    },
    async updateCustomerOwnedDetails() {
      this.editCustomerOwnedEquipmentDetails = true;
      let payload = {
        equipmentId: this.equipmentId,
        contractor: this.contractor,

        jobSiteId:
          this.jobSiteId != null && this.jobSiteId != ""
            ? this.jobSiteId["locationId"]
            : null,
        jobSite:
          this.jobSiteId != null && this.jobSiteId != ""
            ? this.jobSiteId["locationName"]
            : this.newJobSite,
        description: this.description,
        customerEquipmentName: this.customerEquipmentName,
        startDate: this.startDate == "" ? null : this.startDate,
        endDate: this.endDate == "" ? null : this.endDate,
      };
      try {
        let response = await telematicsService.updateCustomerOwnedDetails(
          payload
        );
        if (response.isSuccess) {
          this.$toast.success(
            "Updated Customer Owned Equipment Details successfully."
          );
          this.editCustomerOwnedEquipmentDetails = false;
          this.showCustDialog = false;
          this.readDataFromApi();
        } else {
          this.$toast.error(response.systemMessage);
          this.editCustomerOwnedEquipmentDetails = false;
        }
      } catch (err) {
        this.$toast.error(
          "Unable to Update Customer Owned Equipment Details " + err
        );

        this.editCustomerOwnedEquipmentDetails = false;
      }
    },
  },
};
